export const fetchTranslations = async () => {
  await fetch('/__/translations')
    .then(response => response.json())
    .then(data => {
      window.__CLIENT_TRANSLATIONS__ = data;
      const event = new CustomEvent('translationsUpdated', {detail: data});
      document.dispatchEvent(event);
    });
};
